
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressSavingsFR]",
      function () {
        return require("private-next-pages/[...wordpressSavingsFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressSavingsFR]"])
      });
    }
  